import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import Address from "../searchresults/Address";
import getPersonName from "../common/Name";
import getPhone from "../common/Phone";

class NeighborSubjectDetail extends Component {
  componentDidMount() {}

  render() {
    const neighborPersons = [];
    if (
      this.props.neighborsAddressNode !== undefined &&
      this.props.neighborsAddressNode !== null
    ) {
      const persons = _.get(
        this.props.neighborsAddressNode,
        "neighbours[0].person"
      );
      let neighborAddress = "";
      let neighborRows = [];
      _.forEach(persons, (person, index) => {
        const colorClass = index % 2 === 0 ? "odd-row" : "even-row";
        const personAddress = person.address[0];
        const currentNeighborAddress = `${_.get(
          personAddress,
          "houseNumber[0]._",
          ""
        )} ${_.get(personAddress, "streetName[0]._", "")} ${_.get(
          personAddress,
          "streetSuffix[0]._",
          ""
        )}, ${_.get(personAddress, "city[0]._", "")}, ${_.get(
          personAddress,
          "state[0]._",
          ""
        )} ${_.get(personAddress, "zip[0]._", "")}`;
        if (neighborAddress !== currentNeighborAddress) {
          const neighborDateFrom = _.get(personAddress, "dateFrom[0]._", "");
          const neighborDateTo = _.get(personAddress, "dateTo[0]._", "");
          neighborRows.push(
            <Table.Row
              key={`Neig_Pers_${index}`}
              className="report-sub-sub-sub-section-header"
            >
              <Table.Cell colSpan={5}>
                Neigbors At
                <Address
                  addressNode={personAddress}
                  {...this.props}
                  fullAddress={_.get(personAddress, "fullAddress[0]._")}
                  ignoreLine1
                  noBreakIconsAndText
                  houseNumber={_.get(personAddress, "houseNumber[0]._", "")}
                />
              </Table.Cell>
              <Table.Cell width={4} className={"text-right"}>
                {`${neighborDateFrom}${
                  neighborDateFrom !== "" ? "-" : ""
                }${neighborDateTo}`}
              </Table.Cell>
            </Table.Row>
          );
          neighborPersons.push(neighborRows);
          neighborAddress = currentNeighborAddress;
          neighborRows = [];
        }
        const apt = _.get(person, "address[0].unitDesignatorNumber[0]._");
        const cols = [];
        cols.push(
          <Table.Cell key={`nei_res_pers_name_title_${index}`}>
            <span className="text-bold"> Name: </span>
          </Table.Cell>
        );
        cols.push(
          <Table.Cell key={`nei_res_pers_name_${index}`}>
            {getPersonName(
              _.get(person, "firstName[0]._", ""),
              _.get(person, "middleName[0]._", ""),
              _.get(person, "lastName[0]._", ""),
              this.props
            )}
          </Table.Cell>
        );
        cols.push(
          <Table.Cell key={`nei_res_pers_age_title_${index}`}>
            <span className="text-bold">Age:</span>
          </Table.Cell>
        );
        cols.push(
          <Table.Cell key={`nei_res_pers_age_${index}`}>
            {_.get(person, "age[0]._")}
          </Table.Cell>
        );
        cols.push(
          <Table.Cell key={`nei_res_pers_phone_title_${index}`}>
            {" "}
            <span className="text-bold">
              {person.phone === undefined || person.phone[0] === undefined
                ? ""
                : "Phone:"}{" "}
            </span>
          </Table.Cell>
        );
        cols.push(
          <Table.Cell key={`nei_res_pers_phone_${index}`}>
            {getPhone(_.get(person, "phone[0]._"), this.props)}
            {apt !== undefined ? ` Apt: ${apt}` : ""}
          </Table.Cell>
        );
        neighborRows.push(
          <Table.Row key={`Con_Res_Header_Row_${index}`} className={colorClass}>
            {cols}
          </Table.Row>
        );
      });
      if (neighborRows.length > 0) {
        neighborPersons.push(neighborRows);
      }
    }
    const dateFrom = _.get(
      this.props.neighborsAddressNode,
      "dateFrom[0]._",
      ""
    );
    const dateTo = _.get(this.props.neighborsAddressNode, "dateTo[0]._", "");
    return (
      <div>
        <Table stackable key={"Common_Residency_Header_Name"}>
          <Table.Body>
            <Table.Row className="report-sub-section-header">
              <Table.HeaderCell colSpan={5} width={10}>
                Subject At:{" "}
                <Address
                  addressNode={this.props.neighborsAddressNode}
                  {...this.props}
                  fullAddress={_.get(
                    this.props.neighborsAddressNode,
                    "fullAddress[0]._"
                  )}
                  ignoreLine1
                  noBreakIconsAndText
                />
              </Table.HeaderCell>
              <Table.HeaderCell width={6} className={"text-right"}>
                {`${dateFrom}${dateFrom !== "" ? "-" : ""}${dateTo}`}
              </Table.HeaderCell>
            </Table.Row>
            {neighborPersons}
          </Table.Body>
        </Table>
        <br />
      </div>
    );
  }
}

export default NeighborSubjectDetail;



// WEBPACK FOOTER //
// ./src/components/reports/NeighborSubjectDetail.js